import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Textarea from '../../../../components/form/Textarea'

const CompletionSection = () => {
  const { t } = useTranslation('editDynamicServiceOrders')

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('completionSection')}
      </Title>
      <Line />
      <Separator weight={4} />

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%" wrapOn="sm">
          <FormItem label={t('completionTitleMessage')} path={['configuration', 'titleMessage']} />
        </Col>
      </Grid>

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%" wrapOn="sm">
          <FormItem label={t('completionBodyMessage')} path={['configuration', 'bodyMessage']} Input={Textarea} />
        </Col>
      </Grid>
    </>
  )
}

export default CompletionSection
